
import styled from 'styled-components'
import { themes } from 'theme/styled'

export const ReportsLabel = styled.h3`
  color: ${themes.Light.colors.primary};
`

export const ReportsContentContainer = styled.div`
  margin-top: 42;
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`
